<template>
  <form @submit.prevent="store">
    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
      <text-input v-model="form.serial" :error="form.errors.serial" class="pb-8 pr-6 w-full" label="Barcode" />
    </div>

    <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
      <loading-button :loading="form.processing" class="btn-indigo" type="submit">Boek opslaan</loading-button>
    </div>
  </form>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    LoadingButton,    
    TextInput
  },
  props: {
    book: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        serial: ''
      }),
    }
  },
  methods: {
    store() {
      this.form.post(`/books/${this.book.data.id}/item`)
    },
  },
}
</script>

